import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const BannerContainer = styled.div`
  position: relative;
  display: ${({ closeBanner }) =>
    closeBanner
      ? css`
          display: none;
        `
      : css`
          display: inline-flex;
        `};
  padding: 24px 0px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 19px;
  width: 100%;
  height: fit-content;
  margin-bottom: 12px;
  @media (min-width: 1366px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        width: 97%;
        margin-left: 18px;
        margin-right: 18px;
      `}
  }
  @media (max-width: 1180px) {
    width: 100%;
    margin-left: 0px;
    margin-right: 0px;
  }
  @media (max-width: 821px) {
    width: 95%;
    margin-left: 16px;
    margin-right: 0px;
  }
  @media (max-width: 430px) {
    width: 100vw;
    margin-top: 16px;
    margin-left: -16px;
    margin-right: 0px;
    padding: 16px 21px;
  }
`;

const IconElement = styled.img`
  @media (max-width: 821px) {
    margin-bottom: 24px;
  }
`;

const CloseBanner = styled.img`
  position: absolute;
  right: 0;
  top: 4px;
  cursor: pointer;
  background: ${select('grayBanvi')};
  width: 20px;
  @media (max-width: 430px) {
    right: 21px;
    top: -4px;
  }
`;

const BodyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 32px 38px 32px 38px;
  align-items: flex-start;
  gap: 101px;
  width: 100%;
  height: ${({ isParticular }) => (isParticular ? '128px' : '116px')};
  border-radius: 8px 0px 8px 8px;
  border: 1px solid ${select('neutralDarkGray')};
  background: ${select('bgBanneri24Full')};
  @media (max-width: 821px) {
    height: 176px;
    flex-direction: column;
    align-items: flex-start;
    align-items: flex-start;
    gap: 0;
    padding: 32px 38px;
  }
  @media (max-width: 430px) {
    flex-direction: column;
    align-items: flex-start;
    align-items: flex-start;
    height: fit-content;
  }
`;

const DivContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: 80px;
  @media (max-width: 821px) {
    margin-left: 0px;
  }
  @media (max-width: 430px) {
    flex-direction: column;
    align-items: flex-start;
    align-items: flex-start;
  }
`;

const TextContainer = styled.p`
  color: ${select('black')};
  max-width: 434px;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  white-space: break-spaces;

  @media (max-width: 430px) {
    font-size: 26px;
  }
`;

const SubTitle = styled.span`
  color: ${select('black')};
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  display: ${({ isParticular }) => (isParticular ? 'none' : 'flex')};
  max-width: 434px;
  max-height: 32px;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;
  @media (max-width: 430px) {
    font-size: 16px;
    margin-bottom: 24px;
    margin-top: 8px;
  }
`;

const MoreInfo = styled.a`
  display: flex;
  flex-direction: row;
  height: 48px;
  width: 139px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: ${select('orange')};
  color: ${select('white')};
  text-align: center;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  text-decoration: none;
  @media (max-width: 430px) {
    width: 100%;
  }
`;

const IconCTA = styled.img``;

export {
  BannerContainer,
  IconElement,
  BodyContainer,
  DivContainer,
  SubTitle,
  TextContainer,
  MoreInfo,
  IconCTA,
  CloseBanner
};
